var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shipping_progress_bar" }, [
    _c("div", { staticClass: "progress_bar_wrapper" }, [
      _c(
        "div",
        {
          key: _vm.updateSwitch,
          staticClass: "cash",
          class: { _flying: _vm.flying },
          style: {
            transform: `translateX(${
              _vm.animatedProgressOverride !== false
                ? _vm.progressToPx(_vm.animatedProgressOverride)
                : _vm.progressToPx(_vm.progressData)
            })`,
          },
        },
        [
          _c("div", { class: { _pulse: _vm.celebrating } }, [
            _c("div", { class: { _shimmy: _vm.celebrating } }, [
              _c("img", {
                staticClass: "_wad",
                attrs: { src: _vm.theme.images.cash_wad, role: "presentation" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "_left_wing" }, [
                _c("img", {
                  attrs: {
                    src: _vm.theme.images.cash_left_wing,
                    role: "presentation",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "_right_wing" }, [
                _c("img", {
                  attrs: {
                    src: _vm.theme.images.cash_right_wing,
                    role: "presentation",
                  },
                }),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "progress_bar" }, [
        _c("div", {
          staticClass: "progress_bar_fill",
          style: {
            transform: `translateX(${
              _vm.animatedProgressOverride !== false
                ? _vm.animatedProgressOverride
                : _vm.progressData
            }%)`,
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "shipping_bar_message",
      domProps: { innerHTML: _vm._s(_vm.message) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }